import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons';
import ReactPlayer from 'react-player';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
var Theme = {
  colour: {
    primary: "#E5056A",
    primaryLight: "#ef258a",
    primaryDark: "#b01285",
    secondary: "#f6b12c",
    secondaryLight: "#f7c341",
    secondaryDark: "#f27f23",
    accent: "#00b259",
    accent2: "#009149",
    white: "white",
    grey1: "rgb(240, 240, 240)",
    grey2: "rgb(220, 220, 220)",
    grey3: "rgb(200, 200, 200)",
    grey4: "rgb(180, 180, 180)",
    grey5: "rgb(160, 160, 160)",
    dark: "rgb(80, 80, 80)",
    darkest: "rgb(30, 30, 30)"
  },
  fontSize: {
    body: "16px",
    smallHeading: "22px",
    mediumHeading: "35px",
    subHeading: "40px",
    largeHeading: "67px"
  },
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    browser: "1000px"
  }
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: ", ";\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  box-sizing: border-box;\n"], ["\n  text-align: ", ";\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n  box-sizing: border-box;\n"])), function (p) {
  return p.center ? 'center' : 'left';
});
var HeadingStyle = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media (max-width: 700px) {\n    font-size: ", ";\n  }\n  font-size: ", ";\n  font-weight: 800;\n  padding: 0;\n  margin: 0;\n  overflow-wrap: break-word;\n  user-select: none;\n  line-height: ", ";\n  @media (max-width: 700px) {\n    margin-bottom: 0;\n  }\n  margin-bottom: 10px;\n"], ["\n  @media (max-width: 700px) {\n    font-size: ", ";\n  }\n  font-size: ", ";\n  font-weight: 800;\n  padding: 0;\n  margin: 0;\n  overflow-wrap: break-word;\n  user-select: none;\n  line-height: ", ";\n  @media (max-width: 700px) {\n    margin-bottom: 0;\n  }\n  margin-bottom: 10px;\n"])), Theme.fontSize.subHeading, Theme.fontSize.largeHeading, Theme.fontSize.largeHeading);
var SubHeadingStyle = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (max-width: 700px) {\n    font-size: ", ";\n  }\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  overflow-wrap: break-word;\n  font-weight: 600;\n  user-select: none;\n  color: ", ";\n  line-height: ", ";\n  margin-bottom: 7px;\n"], ["\n  @media (max-width: 700px) {\n    font-size: ", ";\n  }\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  overflow-wrap: break-word;\n  font-weight: 600;\n  user-select: none;\n  color: ", ";\n  line-height: ", ";\n  margin-bottom: 7px;\n"])), Theme.fontSize.mediumHeading, Theme.fontSize.subHeading, Theme.colour.dark, Theme.fontSize.subHeading);
var Body = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  user-select: none;\n  line-height: 26px;\n  font-weight: 200;\n"], ["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  user-select: none;\n  line-height: 26px;\n  font-weight: 200;\n"])), Theme.fontSize.body);
var Title = function Title(_a) {
  var Heading = _a.Heading,
    _b = _a.SubHeading,
    SubHeading = _b === void 0 ? '' : _b,
    _c = _a.Text,
    Text = _c === void 0 ? '' : _c,
    _d = _a.Center,
    Center = _d === void 0 ? false : _d;
  return React.createElement(Container, {
    center: Center
  }, React.createElement(HeadingStyle, null, Heading), SubHeading !== '' && React.createElement(SubHeadingStyle, {
    center: Center
  }, SubHeading), Text !== '' && React.createElement(Body, {
    dangerouslySetInnerHTML: {
      __html: Text
    }
  }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
var Main = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: column;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: column;\n"])), function (p) {
  return p.center ? 'center' : 'flex-start';
}, function (p) {
  return p.center ? 'center' : 'flex-start';
});
var Container$1 = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  width: 100%;\n  text-align: ", ";\n  display: flex;\n  justify-content: ", ";\n  flex-direction: ", ";\n  flex-wrap: wrap;\n"], ["\n  width: 100%;\n  text-align: ", ";\n  display: flex;\n  justify-content: ", ";\n  flex-direction: ", ";\n  flex-wrap: wrap;\n"])), function (p) {
  return p.center ? 'center' : 'left';
}, function (p) {
  return p.center ? 'center' : 'flex-start';
}, function (p) {
  return p.center ? 'row' : 'column';
});
var CreditContainer = styled.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  margin-bottom: 5px;\n  margin-right: ", ";\n  margin-left: ", ";\n"], ["\n  margin-bottom: 5px;\n  margin-right: ", ";\n  margin-left: ", ";\n"])), function (p) {
  return p.center ? '15px' : 0;
}, function (p) {
  return p.center ? '15px' : 0;
});
var CreditName = styled.span(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  user-select: none;\n  cursor: ", ";\n  :hover {\n    color: ", ";\n  }\n  :active {\n    color: ", ";\n  }\n  transition: color 0.3s ease;\n  padding-left: 5px;\n  font-weight: 200;\n"], ["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  user-select: none;\n  cursor: ", ";\n  :hover {\n    color: ", ";\n  }\n  :active {\n    color: ", ";\n  }\n  transition: color 0.3s ease;\n  padding-left: 5px;\n  font-weight: 200;\n"])), Theme.fontSize.body, function (p) {
  return p.clickable ? 'pointer' : 'default';
}, function (p) {
  return p.clickable ? Theme.colour.secondary : Theme.colour.grey5;
}, function (p) {
  return p.clickable ? Theme.colour.primary : Theme.colour.grey5;
});
var CreditTitle = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  color: ", ";\n  user-select: none;\n  font-weight: 200;\n"], ["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  color: ", ";\n  user-select: none;\n  font-weight: 200;\n"])), Theme.fontSize.body, Theme.colour.accent2);
var Credits = function Credits(_a) {
  var Credits = _a.Credits,
    _b = _a.Stacked,
    Stacked = _b === void 0 ? false : _b,
    onClick = _a.onClick;
  var Click = function Click(link) {
    if (link && onClick) {
      onClick(link);
    }
  };
  return React.createElement(Main, {
    center: !Stacked
  }, React.createElement(Container$1, {
    center: !Stacked
  }, Credits.map(function (credit, index) {
    return React.createElement(CreditContainer, {
      center: !Stacked,
      key: "" + credit.title + credit.name + index
    }, React.createElement(CreditTitle, null, credit.title, " :"), React.createElement(CreditName, {
      clickable: credit.link !== undefined,
      center: !Stacked,
      onClick: function onClick() {
        return Click(credit.link);
      }
    }, credit.name));
  })));
};
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5;
var ContainerImage = styled.div(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  height: 100%;\n  width: 100%;\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  box-sizing: border-box;\n"], ["\n  height: 100%;\n  width: 100%;\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  box-sizing: border-box;\n"])), function (p) {
  return p.url;
});
var Container$2 = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n"], ["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n"])));
var ImageStyle = styled.img(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  max-width: 100%;\n  max-height: 100%;\n"], ["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var Image = function Image(_a) {
  var Image = _a.Image,
    _b = _a.Cropped,
    Cropped = _b === void 0 ? false : _b;
  return React.createElement(React.Fragment, null, Cropped ? React.createElement(ContainerImage, {
    url: Image
  }) : React.createElement(Container$2, null, React.createElement(ImageStyle, {
    src: Image,
    cropped: Cropped
  })));
};
var templateObject_1$2, templateObject_2$2, templateObject_3$2;
var Container$3 = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"], ["\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"])));
var ContainerImage$1 = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  flex-grow: 1;\n  width: 100%;\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  box-sizing: border-box;\n  :first-child {\n    margin-top: 0px;\n  }\n  margin-top: 10px;\n"], ["\n  flex-grow: 1;\n  width: 100%;\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  box-sizing: border-box;\n  :first-child {\n    margin-top: 0px;\n  }\n  margin-top: 10px;\n"])), function (p) {
  return p.url;
});
var Images = function Images(_a) {
  var Images = _a.Images;
  return React.createElement(Container$3, null, Images.map(function (image, index) {
    return React.createElement(ContainerImage$1, {
      key: "" + image + index,
      url: image
    });
  }));
};
var templateObject_1$3, templateObject_2$3;
var Container$4 = styled.div(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  text-align: ", ";\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: ", ";\n  flex-direction: column;\n  box-sizing: border-box;\n"], ["\n  text-align: ", ";\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: ", ";\n  flex-direction: column;\n  box-sizing: border-box;\n"])), function (p) {
  return p.center ? 'center' : 'left';
}, function (p) {
  return p.center ? 'center' : 'flex-start';
});
var QuoteStyle = styled.p(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  overflow-wrap: break-word;\n  user-select: none;\n  font-weight: 200;\n"], ["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  overflow-wrap: break-word;\n  user-select: none;\n  font-weight: 200;\n"])), Theme.fontSize.smallHeading);
var AuthorStyle = styled.p(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  color: ", ";\n  user-select: none;\n  text-align: justify;\n  line-height: 22px;\n  font-weight: 200;\n"], ["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  color: ", ";\n  user-select: none;\n  text-align: justify;\n  line-height: 22px;\n  font-weight: 200;\n"])), Theme.fontSize.body, Theme.colour.accent2);
var Divider = styled.div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), function (p) {
  return p.height;
});
var QuoteMark = styled(FontAwesomeIcon)(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  font-size: 18px;\n  padding: 0;\n  margin: 0;\n  color: ", ";\n  user-select: none;\n  transform: translateY(-5px);\n"], ["\n  font-size: 18px;\n  padding: 0;\n  margin: 0;\n  color: ", ";\n  user-select: none;\n  transform: translateY(-5px);\n"])), Theme.colour.accent);
var Gap = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block;\n  width: 10px;\n"], ["\n  display: inline-block;\n  width: 10px;\n"])));
var Quote = function Quote(_a) {
  var Quote = _a.Quote,
    Author = _a.Author,
    _b = _a.Center,
    Center = _b === void 0 ? false : _b;
  return React.createElement(Container$4, {
    center: Center
  }, React.createElement(QuoteStyle, null, React.createElement(QuoteMark, {
    icon: faQuoteLeft
  }), React.createElement(Gap, null), Quote, React.createElement(Gap, null), React.createElement(QuoteMark, {
    icon: faQuoteRight
  })), React.createElement(Divider, {
    height: '10px'
  }), Author && React.createElement(AuthorStyle, null, "- ", Author));
};
var templateObject_1$4, templateObject_2$4, templateObject_3$3, templateObject_4$2, templateObject_5$1, templateObject_6;
var Video = function Video(_a) {
  var Link = _a.Link;
  return React.createElement(ReactPlayer, {
    url: Link,
    controls: true,
    width: '100%',
    height: '100%'
  });
};
var Container$5 = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  text-align: ", ";\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: ", ";\n  flex-direction: column;\n  box-sizing: border-box;\n"], ["\n  text-align: ", ";\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: ", ";\n  flex-direction: column;\n  box-sizing: border-box;\n"])), function (p) {
  return p.center ? 'center' : 'left';
}, function (p) {
  return p.center ? 'center' : 'flex-start';
});
var HeadingStyle$1 = styled.p(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: 800;\n  padding: 0;\n  margin: 0;\n  overflow-wrap: break-word;\n  user-select: none;\n  line-height: ", ";\n  margin-bottom: 10px;\n"], ["\n  font-size: ", ";\n  font-weight: 800;\n  padding: 0;\n  margin: 0;\n  overflow-wrap: break-word;\n  user-select: none;\n  line-height: ", ";\n  margin-bottom: 10px;\n"])), Theme.fontSize.mediumHeading, Theme.fontSize.mediumHeading);
var Button = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  color: white;\n  background-color: ", ";\n  padding: 5px 15px 5px 15px;\n  border-radius: 5px;\n  overflow-wrap: break-word;\n  user-select: none;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n  }\n  :active {\n    background-color: ", ";\n  }\n  margin-right: 8px;\n  margin-bottom: 8px;\n  transition: background-color 0.3s ease;\n"], ["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  color: white;\n  background-color: ", ";\n  padding: 5px 15px 5px 15px;\n  border-radius: 5px;\n  overflow-wrap: break-word;\n  user-select: none;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n  }\n  :active {\n    background-color: ", ";\n  }\n  margin-right: 8px;\n  margin-bottom: 8px;\n  transition: background-color 0.3s ease;\n"])), Theme.fontSize.body, Theme.colour.secondary, Theme.colour.secondaryLight, Theme.colour.accent);
var ButtonsStyle = styled.div(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ", ";\n"], ["\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ", ";\n"])), function (p) {
  return p.center ? 'center' : 'flex-start';
});
var Body$1 = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  user-select: none;\n  line-height: 26px;\n  font-weight: 200;\n"], ["\n  font-size: ", ";\n  padding: 0;\n  margin: 0;\n  user-select: none;\n  line-height: 26px;\n  font-weight: 200;\n"])), Theme.fontSize.body);
var Divider$1 = styled.div(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  height: ", ";\n"], ["\n  height: ", ";\n"])), function (p) {
  return p.height;
});
var Paragraph = function Paragraph(_a) {
  var _b = _a.Heading,
    Heading = _b === void 0 ? '' : _b,
    Text = _a.Text,
    _c = _a.Buttons,
    Buttons = _c === void 0 ? [] : _c,
    _d = _a.Center,
    Center = _d === void 0 ? false : _d,
    _e = _a.onClick,
    _onClick = _e === void 0 ? function () {} : _e;
  return React.createElement(Container$5, {
    center: Center
  }, Heading !== '' && React.createElement(HeadingStyle$1, null, Heading), React.createElement(Body$1, {
    dangerouslySetInnerHTML: {
      __html: Text
    }
  }), Buttons.length > 0 && React.createElement(Divider$1, {
    height: '10px'
  }), Buttons.length > 0 && React.createElement(ButtonsStyle, {
    center: Center
  }, Buttons.map(function (button, index) {
    return React.createElement("div", {
      key: "" + button.title + index
    }, React.createElement(Button, {
      onClick: function onClick() {
        return _onClick(button.link);
      }
    }, button.title));
  })));
};
var templateObject_1$5, templateObject_2$5, templateObject_3$4, templateObject_4$3, templateObject_5$2, templateObject_6$1;
var Container$6 = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  grid-auto-rows: ", ";\n  grid-gap: 5px;\n"], ["\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  grid-auto-rows: ", ";\n  grid-gap: 5px;\n"])), function (p) {
  return p.square ? '300px' : '200px';
});
var Image$1 = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  :hover {\n    filter: saturate(0) brightness(0.9);\n  }\n  :active {\n    filter: saturate(0) brightness(0.7);\n  }\n  transition: filter 0.3s ease;\n"], ["\n  width: 100%;\n  height: 100%;\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  box-sizing: border-box;\n  cursor: pointer;\n  :hover {\n    filter: saturate(0) brightness(0.9);\n  }\n  :active {\n    filter: saturate(0) brightness(0.7);\n  }\n  transition: filter 0.3s ease;\n"])), function (p) {
  return p.url;
});
var BGAnim = keyframes(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  from { background-color: rgba(0, 0, 0, 0) }\n  to { background-color: rgba(0, 0, 0, 0.75) }\n"], ["\n  from { background-color: rgba(0, 0, 0, 0) }\n  to { background-color: rgba(0, 0, 0, 0.75) }\n"])));
var Fixed = styled.div(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  padding: 50px;\n  box-sizing: border-box;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: ", " 0.3s ease;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  padding: 50px;\n  box-sizing: border-box;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: ", " 0.3s ease;\n"])), BGAnim);
var Scale = keyframes(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  from { transform: scale(0) }\n  to { transform: scale(1) }\n"], ["\n  from { transform: scale(0) }\n  to { transform: scale(1) }\n"])));
var FullScreen = styled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 1000px;\n  height: 100%;\n  max-height: 600px;\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  box-sizing: border-box;\n  user-select: none;\n  position: relative;\n  animation: ", " 0.3s ease;\n  overflow: hidden;\n  border-radius: 5px;\n"], ["\n  width: 100%;\n  max-width: 1000px;\n  height: 100%;\n  max-height: 600px;\n  background: url(", ");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  box-sizing: border-box;\n  user-select: none;\n  position: relative;\n  animation: ", " 0.3s ease;\n  overflow: hidden;\n  border-radius: 5px;\n"])), function (p) {
  return p.url;
}, Scale);
var Cross = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 40px;\n  height: 40px;\n  background-color: rgb(50, 50, 50);\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border-radius: 20px;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n  }\n  :active {\n    background-color: ", ";\n  }\n  transition: background-color 0.3s ease;\n"], ["\n  width: 40px;\n  height: 40px;\n  background-color: rgb(50, 50, 50);\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border-radius: 20px;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n  }\n  :active {\n    background-color: ", ";\n  }\n  transition: background-color 0.3s ease;\n"])), Theme.colour.secondary, Theme.colour.accent);
var Line = styled.line(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  fill: none;\n  stroke: white;\n  stroke-miterlimit: 10;\n  stroke-width: 2px;\n  stroke-linecap: round;\n"], ["\n  fill: none;\n  stroke: white;\n  stroke-miterlimit: 10;\n  stroke-width: 2px;\n  stroke-linecap: round;\n"])));
var PolyLine = styled.polyline(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  fill: none;\n  stroke: white;\n  stroke-miterlimit: 10;\n  stroke-width: 2px;\n  stroke-linecap: round;\n"], ["\n  fill: none;\n  stroke: white;\n  stroke-miterlimit: 10;\n  stroke-width: 2px;\n  stroke-linecap: round;\n"])));
var Arrow = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  width: 40px;\n  height: 40px;\n  background-color: transparent;\n  transition: background-color 0.3s ease;\n"], ["\n  width: 40px;\n  height: 40px;\n  background-color: transparent;\n  transition: background-color 0.3s ease;\n"])));
var Bar = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 60px;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  :hover {\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n  transition: background-color 0.3s ease;\n  :active {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 60px;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  :hover {\n    background-color: rgba(0, 0, 0, 0.4);\n  }\n  transition: background-color 0.3s ease;\n  :active {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n"])));
var LeftBar = styled(Bar)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  left: 0;\n"], ["\n  left: 0;\n"])));
var RightBar = styled(Bar)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  right: 0;\n"], ["\n  right: 0;\n"])));
var Gallery = function Gallery(_a) {
  var Images = _a.Images,
    _b = _a.Square,
    Square = _b === void 0 ? false : _b;
  var _c = useState(0),
    currentIndex = _c[0],
    setCurrentIndex = _c[1];
  var _d = useState(false),
    fullscreenActive = _d[0],
    setFullscreenActive = _d[1];
  var ImageClick = function ImageClick(index) {
    setCurrentIndex(index);
    setFullscreenActive(true);
  };
  var stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
  };
  var leftClick = function leftClick() {
    var length = Images.length;
    if (currentIndex === 0) {
      setCurrentIndex(length - 1);
    } else {
      setCurrentIndex(currentIndex - 1);
    }
  };
  var rightClick = function rightClick() {
    var length = Images.length;
    if (currentIndex === length - 1) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  };
  return React.createElement(Container$6, {
    square: Square
  }, Images.map(function (image, index) {
    return React.createElement(Image$1, {
      url: image,
      key: "" + image + index,
      onClick: function onClick() {
        return ImageClick(index);
      }
    });
  }), fullscreenActive && React.createElement(Fixed, {
    onClick: function onClick() {
      return setFullscreenActive(false);
    }
  }, React.createElement(FullScreen, {
    url: Images[currentIndex],
    onClick: stopPropagation
  }, React.createElement(LeftBar, {
    onClick: leftClick
  }, React.createElement(Arrow, null, React.createElement("svg", {
    viewBox: '0 0 50 50'
  }, React.createElement(PolyLine, {
    points: '29 37 17 25 29 13 17 25'
  })))), React.createElement(RightBar, {
    onClick: rightClick
  }, React.createElement(Arrow, null, React.createElement("svg", {
    viewBox: '0 0 50 50'
  }, React.createElement(PolyLine, {
    points: '21 13 33 25 21 37 33 25'
  })))), React.createElement(Cross, {
    onClick: function onClick() {
      return setFullscreenActive(false);
    }
  }, React.createElement("svg", {
    viewBox: '0 0 50 50'
  }, React.createElement(Line, {
    x1: '13',
    y1: '13',
    x2: '37',
    y2: '37'
  }), React.createElement(Line, {
    x1: '37',
    y1: '13',
    x2: '13',
    y2: '37'
  }))))));
};
var templateObject_1$6, templateObject_2$6, templateObject_3$5, templateObject_4$4, templateObject_5$3, templateObject_6$2, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
var Container$7 = styled.div(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  width: 100%;\n  text-align: ", ";\n  display: flex;\n  justify-content: ", ";\n  flex-direction: ", ";\n  flex-wrap: wrap;\n"], ["\n  width: 100%;\n  text-align: ", ";\n  display: flex;\n  justify-content: ", ";\n  flex-direction: ", ";\n  flex-wrap: wrap;\n"])), function (p) {
  return p.center ? 'center' : 'left';
}, function (p) {
  return p.center ? 'center' : 'flex-start';
}, function (p) {
  return p.center ? 'row' : 'column';
});
var Button$1 = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  background-color: red;\n  width: max-content;\n  box-sizing: border-box;\n  padding: 6px 7px 6px 7px;\n  border-radius: ", ";\n  cursor: pointer;\n  background-color: ", ";\n  :hover {\n    background-color: ", ";\n  }\n  transition: background-color 0.3s ease;\n  :active {\n    background-color: ", ";\n  }\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n  margin-right: ", ";\n  margin-left: ", ";\n"], ["\n  background-color: red;\n  width: max-content;\n  box-sizing: border-box;\n  padding: 6px 7px 6px 7px;\n  border-radius: ", ";\n  cursor: pointer;\n  background-color: ", ";\n  :hover {\n    background-color: ", ";\n  }\n  transition: background-color 0.3s ease;\n  :active {\n    background-color: ", ";\n  }\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n  margin-right: ", ";\n  margin-left: ", ";\n"])), function (p) {
  return p.center ? '5px' : '0 5px 5px 0';
}, Theme.colour.primary, Theme.colour.secondary, Theme.colour.accent, function (p) {
  return p.center ? '5px' : 0;
}, function (p) {
  return p.center ? '5px' : 0;
});
var Icon = styled.p(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  color: white;\n  font-size: 30px;\n  padding: 0;\n  margin: 0;\n  line-height: 0;\n  display: inline-block;\n"], ["\n  color: white;\n  font-size: 30px;\n  padding: 0;\n  margin: 0;\n  line-height: 0;\n  display: inline-block;\n"])));
var Text = styled.span(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  color: white;\n  font-size: 16px;\n  padding: 0;\n  margin: 0;\n  line-height: 0;\n  user-select: none;\n  font-weight: 200;\n"], ["\n  color: white;\n  font-size: 16px;\n  padding: 0;\n  margin: 0;\n  line-height: 0;\n  user-select: none;\n  font-weight: 200;\n"])));
var Gap$1 = styled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  width: 7px;\n"], ["\n  width: 7px;\n"])));
var Links = function Links(_a) {
  var Links = _a.Links,
    Stacked = _a.Stacked,
    _b = _a.onClick,
    _onClick2 = _b === void 0 ? function () {} : _b;
  return React.createElement(Container$7, {
    center: !Stacked
  }, Links.map(function (link, index) {
    return React.createElement(Button$1, {
      center: !Stacked,
      key: "" + link.icon + index,
      onClick: function onClick() {
        return _onClick2(link.url);
      }
    }, React.createElement(Icon, null, React.createElement("i", {
      className: "" + link.icon
    })), link.title && React.createElement(React.Fragment, null, React.createElement(Gap$1, null), React.createElement(Text, null, link.title), React.createElement(Gap$1, null)));
  }));
};
var templateObject_1$7, templateObject_2$7, templateObject_3$6, templateObject_4$5, templateObject_5$4;
var Container$8 = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  background-color: white;\n"], ["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  background-color: white;\n"])));
var IframeContainer = styled.iframe(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var Iframe = function Iframe(_a) {
  var Link = _a.Link;
  return React.createElement(Container$8, null, React.createElement(IframeContainer, {
    src: Link,
    frameBorder: 0
  }));
};
var templateObject_1$8, templateObject_2$8;
export { Credits, Gallery, Iframe, Image, Images, Links, Paragraph, Quote, Title, Video };